import { OnInit } from '@angular/core';
var HowItWorksAdvisorComponent = /** @class */ (function () {
    function HowItWorksAdvisorComponent() {
    }
    HowItWorksAdvisorComponent.prototype.ngOnInit = function () {
    };
    return HowItWorksAdvisorComponent;
}());
export { HowItWorksAdvisorComponent };
